module.exports = __webpack_public_path__ + "media/images/wallet/payment5-53ed189d027c1fd8357be19b23e468c2.svg";